import { useEffect, useState,createContext } from "react";
import {
    Box,
    Tab,
    Tabs
} from '@mui/material';
import { useAppDispatch } from "../../stores/hooks";
import { setcurrentmenu } from "../../stores/menuslice";
import BuildStatus from "./childcomponents/buildstatus";
import BuildFileStatus from "./childcomponents/buildfilestatus";
import { BuildJobInfo } from "../../data/interfaces/jobmodels";
import ReleaseMain from "./childcomponents/releasemain";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  interface ActiveTab{
    activeTab:number,
    setActiveTab:(newValue:number)=>void,
    activeJob:BuildJobInfo|null,
    setActiveJob:(job:BuildJobInfo)=>void
  }


  export const CurrentFolderContext = createContext<ActiveTab>({activeTab:0,setActiveTab:(newValue:number)=>{},activeJob:null,setActiveJob:(job:BuildJobInfo)=>{}});
  
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 1 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }
function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export default function Jobs() {
    const [activeTab, setActiveTab] = useState(0);
    const [activeJob, setActiveJob] = useState<BuildJobInfo|null>(null);
    const value = { activeTab, setActiveTab,activeJob,setActiveJob };
    const dispatch = useAppDispatch();
    
    useEffect(() => {
        dispatch(setcurrentmenu('jobs'));
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    //setValue(newValue);
    setActiveTab(newValue)
  };
    return (
      <CurrentFolderContext.Provider value={value}>
        <Box sx={{ width: '100%',p:1 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} onChange={handleChange} variant="fullWidth" aria-label="Jobs">
                    <Tab label="Build Jobs" {...a11yProps(0)} />
                    <Tab label="Release Jobs" {...a11yProps(1)} />
                    <Tab label="Files" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <TabPanel value={activeTab} index={0}>
                <BuildStatus />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
                <ReleaseMain />
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
                <BuildFileStatus />
            </TabPanel>
        </Box></CurrentFolderContext.Provider>
    );
}